import Train from "../Assests/program-bg-image.png";
import Playgroup from "../Assests/ProgramImages/20251114_105650 (1).jpg";
import Nursery from "../Assests/ProgramImages/SDS_0447.JPG";
import Junior from "../Assests/ProgramImages/SDS_0321.JPG";
import Activity from "../Assests/ProgramImages/SDS_0209.JPG";
import { PROGRAM_SUMMARIES } from "../data/siteContent";

import play1 from "../Assests/Program/PXL_20250627_053707382.jpg"
import daycare from "../Assests/Program/PXL_20250912_052630038.MP.jpg"

const imageMap = {
  "toddler-program": Playgroup,
  "play-group": play1,
  nursery: Nursery,
  "jr-kg": Junior,
  "sr-kg": Activity,
  "day-care": daycare,
};

const iconMap = {
  "toddler-program": "🧸",
  "play-group": "🧸",
  nursery: "🎨",
  "jr-kg": "📚",
  "sr-kg": "🔬",
  "day-care": "☀️",
};

const PROGRAMS = PROGRAM_SUMMARIES.map((program, index) => ({
  ...program,
  id: index + 1,
  title: program.label,
  img: imageMap[program.id] || Activity,
  icon: iconMap[program.id] || "🌱",
}));

const ToyTrain = () => <img src={Train} alt="Toy Train" className="h-full w-full object-contain" />;

export default function OurProgramsSection() {
  return (
    <section className="relative w-full overflow-hidden bg-[#F8F5EE] px-4 py-12 md:px-8 lg:px-16">
      <div className="pointer-events-none absolute left-0 top-0 hidden h-36 w-52 select-none md:block">
        <ToyTrain />
      </div>

      <div className="pointer-events-none absolute left-0 top-0 h-20 w-28 select-none md:hidden">
        <ToyTrain />
      </div>

      <div className="relative z-10 mb-10 text-center">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-1 text-sm font-medium text-gray-700">
          <span className="text-lg font-bold text-[#FF6B35]">*</span>
          Learning Hubs
        </div>
        <h2 className="mx-auto max-w-3xl text-3xl font-extrabold leading-tight text-[#0D1B2A] md:text-4xl lg:text-5xl">
Learning Hubs
        </h2>
        <div className="mt-6 flex justify-center">
          <span className="inline-block h-3 w-3 rounded-full bg-[#FF6B35]"></span>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
        {PROGRAMS.map((program) => (
          <div
            key={program.id}
            className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm transition-shadow duration-200 hover:shadow-md"
          >
            <div className="flex-1 p-5">
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-[#1B4D6E] text-2xl text-white">
                {program.icon}
              </div>
              <div className="mb-2 flex items-center justify-between gap-3">
                <h3 className="text-base font-bold text-[#0D1B2A] md:text-lg">{program.title}</h3>
                <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${program.color}`}>Age {program.age}</span>
              </div>
              <p className="text-sm leading-relaxed text-gray-500">{program.desc}</p>
            </div>
            <div className="h-48 w-full overflow-hidden md:h-44">
              <img
                src={program.img}
                alt={program.title}
                className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
